import { useEffect, useState } from "react";
import { FileUp } from "lucide-react";

import { useAuth } from "@/context/AuthContext";
import BrandSettingsPanel from "@/components/BrandSettingsPanel";
import CommercialRulesPanel from "@/components/CommercialRulesPanel";
import CurrencySettingsPanel from "@/components/CurrencySettingsPanel";
import LotOperationsTable from "@/components/LotOperationsTable";
import UserManagementPanel from "@/components/UserManagementPanel";
import PlanSettingsPanel from "@/components/PlanSettingsPanel";
import LotStatusSettingsPanel from "@/components/LotStatusSettingsPanel";
import PublicViewerSettingsPanel from "@/components/PublicViewerSettingsPanel";
import { api, apiError } from "@/lib/api";

export default function AdminPage() {
  const { user } = useAuth();
  const [lots, setLots] = useState([]);
  const [message, setMessage] = useState("");

  const load = () => {
    api.get("/lots").then((response) => setLots(response.data));
  };

  useEffect(() => {
    load();
  }, []);

  const importFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await api.post("/admin/import-lots", formData);
      setMessage(`${response.data.creados} creados · ${response.data.actualizados} actualizados.`);
      load();
    } catch (error) {
      setMessage(apiError(error));
    }
  };

  return (
    <section className="page admin-page" data-testid="admin-page">
      <header className="page-header compact">
        <div>
          <span className="eyebrow">CONFIGURACIÓN DEL SISTEMA</span>
          <h1>Administración</h1>
          <p>Gestiona inventario, beneficios comerciales y el acceso del equipo.</p>
        </div>
      </header>
      {message && <p className="form-note admin-note" data-testid="admin-action-message">{message}</p>}
      <div className="admin-grid">
        <section className="admin-panel" data-testid="inventory-admin-panel">
          <div className="panel-heading"><div><span className="eyebrow">INVENTARIO</span><h2>Lotes</h2></div>{user.role !== "vendedor" && <label className="outline-button upload-button" data-testid="excel-import-label"><FileUp size={16} /> Importar Excel<input accept=".xlsx,.xls" data-testid="excel-import-input" onChange={importFile} type="file" /></label>}</div>
          <LotOperationsTable lots={lots} onChanged={load} user={user} />
        </section>
      </div>
      {user.role !== "vendedor" && <CommercialRulesPanel />}
      {user.role === "administrador" && <BrandSettingsPanel />}
      {user.role === "administrador" && <CurrencySettingsPanel />}
      {user.role === "administrador" && <PlanSettingsPanel />}
      {user.role === "administrador" && <PublicViewerSettingsPanel />}
      {user.role === "administrador" && <LotStatusSettingsPanel />}
      {user.role === "administrador" && <UserManagementPanel />}
    </section>
  );
}
